module.exports = __webpack_public_path__ + "img/account-logo.838c2b56.svg";